export default {"src":"/_next/static/media/safari.a7d82948.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};